export default __webpack_public_path__ + "static/media/FSIndustrieCd-Bold.e35c3bc3.ttf";